import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { and, or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import Notifications from 'src/scenes/Notifications/index.ts';
import { notificationsQueryParamsSchema } from 'src/scenes/Notifications/pages/SystemNotifications/types.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const notificationsRouteObject = inferRouteObject({
  path: 'notifications',
  element: <Notifications.Helmet />,
  children: [
    {
      path: 'comments',
      element: <PrivateRoute roles={and(or(Roles.ADMIN, Roles.AGENCY))} noAccessComponent={Status.NotFound} />,
      children: [{ index, Component: Notifications.Comments }],
    },
    { path: 'system', Component: Notifications.SystemNotifications, searchParams: notificationsQueryParamsSchema.parse },
    { index, element: <Navigate to='./system' replace /> },
  ],
});
